import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { UtilService } from '@service/util/util.service';
import { ContactsTable, RestService } from 'cargo-chief-commons';
import { UrlService } from '@service/url/url.service';
import { ConfirmationDialogComponent } from '../../common/confirmation-dialog/confirmation-dialog.component';
import { SNACKBAR } from '@domain/constants/snackbar-setting';

@Component({
	selector: 'app-carrier-contact-actions',
	templateUrl: './carrier-contact-actions.component.html',
	styleUrls: ['./carrier-contact-actions.component.scss'],
})
export class CarrierContactActionsComponent implements OnInit {
	@Input() contactList;
	@Input() carrierId;
	@Input() oldCarrierId;
	@Input() carrier;
	@Input() contact: ContactsTable;

	@Output() updatedContacts: EventEmitter<any> = new EventEmitter();

	constructor(
		private restService: RestService,
		private urlService: UrlService,
		private utilService: UtilService,
		public dialog: MatDialog
	) {}

	ngOnInit() {}

	deleteContact(contactToBeDeleted: ContactsTable) {
		const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
			width: '600px',
			data: {
				title: 'Delete Contact',
				body: `Please confirm that you want to delete this contact.`,
				cancelButtonText: 'Cancel',
				ConfirmButtonText: 'Delete',
			},
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (!this.utilService.isNullOrUndefined(result) && result) {
				const url = this.urlService.deleteContact(contactToBeDeleted.id);
				this.restService.DELETE(url).subscribe(
					(result) => {
						this.utilService.showSnackbar('Contact deleted.', SNACKBAR.SUCCESS, SNACKBAR.ACTION);
						this.contactList = this.contactList.filter((contact) => {
							if (
								!(
									contact.id == contactToBeDeleted.id &&
									contact.createdAt == contactToBeDeleted.createdAt &&
									contact.email == contactToBeDeleted.emailAddress
								)
							) {
								return contact;
							}
						});
						this.updatedContacts.emit(this.contactList);
					},
					(error) => {
						this.utilService.showSnackbar(
							'Unable to delete contact now. Please try later.',
							SNACKBAR.ERROR,
							SNACKBAR.ACTION
						);
					}
				);
			}
		});
	}

	authorizeContact(contactToBeAuthorized: ContactsTable) {
		const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
			width: '600px',
			data: {
				title: 'Validate Contact',
				body: 'Please confirm that you want to validate this contact. We must verify in writing that this is the desired contact for the carrier. This will bypass our automated contact validation.',
				cancelButtonText: 'Cancel',
				ConfirmButtonText: 'Validate',
			},
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (!this.utilService.isNullOrUndefined(result) && result) {
				const url = this.urlService.authorizeCarrierContact(contactToBeAuthorized.id);
				this.restService.POST(url, {}).subscribe(
					(result) => {
						this.contactList = this.contactList.map(c =>
							c.id === contactToBeAuthorized.id ? { ...c, vettingAuthorized: true } : c);

						this.utilService.showSnackbar('Contact authorized.', SNACKBAR.SUCCESS, SNACKBAR.ACTION);
						this.updatedContacts.emit(this.contactList);
					},
					(error) => {
						this.utilService.showSnackbar(
							'Unable to authorize contact now. Please try later.',
							SNACKBAR.ERROR,
							SNACKBAR.ACTION
						);
					}
				);
			}
		});
	}

	editedContact(updatedContact) {
		this.contactList.forEach((contact, index) => {
			if (contact.id == updatedContact.contactId) {
				contact.hideName = updatedContact.hideName;
				contact.hidePhone = updatedContact.hidePhone;
				contact.firstName = updatedContact.firstName;
				contact.lastName = updatedContact.lastName;
				contact.emailAddress = updatedContact.email;
				contact.isMailReciever = updatedContact.isMailReciever;
				contact.mobile = updatedContact.mobileNumber;
			}
		});
		this.updatedContacts.emit(this.contactList);
	}
}
